import { BSWDesignSystemError } from '../../../utils/DesignSystemError';

export class LinkInputValidationError extends BSWDesignSystemError {
  constructor(message: string) {
    super(message);
    this.name = 'LinkInputValidationError';
  }
}
